/**
 * CalendarPage — B1.4 Weekly Calendar route entry.
 *
 * Intentionally thin: the page is a fixed-height container that hosts the
 * `WeeklyCalendarContainer` smart wrapper, which owns data, filters, and
 * side sheets. The calendar takes over the entire authenticated main area.
 */
import { WeeklyCalendarContainer } from '@/features/appointments';

export function CalendarPage(): JSX.Element {
  return (
    <div className="h-full min-h-0 flex flex-col">
      <WeeklyCalendarContainer />
    </div>
  );
}
